import { useEffect } from 'react';

/** Adds `.is-in` to every [data-reveal] element as it scrolls into view (once). Stagger via `--i` on children. */
export function useReveal(): void {
    useEffect(() => {
        const nodes = Array.from(document.querySelectorAll<HTMLElement>('[data-reveal]'));
        if (nodes.length === 0) return;
        const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        if (reduce || typeof IntersectionObserver === 'undefined') {
            nodes.forEach((n) => n.classList.add('is-in'));
            return;
        }
        const io = new IntersectionObserver(
            (entries) => {
                for (const e of entries) {
                    if (e.isIntersecting) {
                        e.target.classList.add('is-in');
                        io.unobserve(e.target);
                    }
                }
            },
            { rootMargin: '0px 0px -8% 0px', threshold: 0 }
        );
        nodes.forEach((n) => io.observe(n));
        return () => io.disconnect();
    }, []);
}
